import React from "react";
import styles from "./seventh.module.scss";
import constants from "../../constants/home/blog-cards.constants";
import BlogCard from "../../components/Cards/BlogCard";
const Seventh = () => {
  return (
    <div className={styles.root}>
      <section className={styles.top}>
        <span className={styles.title}>
          <span className="blue-text">Sentinel </span>Blog
        </span>
        <span className={styles.description}>
          Stay up to date on our latest developments
        </span>
      </section>
      <section className={styles.bottom}>
        {constants.map((c, i) => {
          return <BlogCard key={`blog-card-${i}`} data={c} />;
        })}
      </section>
    </div>
  );
};

export default Seventh;
